/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CreateBillingCheckoutBody = zod
	.object({
		intent: zod.enum(['payment_method_setup', 'payment_method_update'])
	})
	.describe('Create a billing checkout session');

export type CreateBillingCheckoutBody = zod.input<typeof CreateBillingCheckoutBody>;
export type CreateBillingCheckoutBodyOutput = zod.output<typeof CreateBillingCheckoutBody>;
